import http from '@/utils/http';

export default {
	list: data => {
		return http({ url: '/api/admin/v1/feeCategory/list', data }).then(r => r);
	},
	create: data => {
		return http({ url: '/api/admin/v1/feeCategory/create', data, tip: true }).then(r => r);
	},
	update: data => {
		return http({ url: '/api/admin/v1/feeCategory/update', data, tip: true }).then(r => r);
	},
	delete: data => {
		return http({ url: '/api/admin/v1/feeCategory/delete', data, tip: true }).then(r => r);
	},
	toggleStatus: data => {
		return http({ url: '/api/admin/v1/feeCategory/toggleStatus', data, tip: true }).then(r => r);
	},
};
